import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

const formatPhone = value => {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 9);
  const first = digits.slice(0, 2);
  const second = digits.slice(2, 5);
  const third = digits.slice(5, 7);
  const fourth = digits.slice(7, 9);

  let result = '';

  if (first) result += `(${first}`;
  if (first.length === 2) result += ')';
  if (second) result += ` ${second}`;
  if (third) result += `-${third}`;
  if (fourth) result += `-${fourth}`;

  return result;
};

const MaskedPhoneInput = ({ value, onChange, ...rest }) => {
  const handleChange = event => {
    onChange(formatPhone(event.target.value));
  };

  return (
    <Input
      {...rest}
      value={formatPhone(value)}
      onChange={handleChange}
      inputMode="numeric"
      placeholder="(90) 123-45-67"
    />
  );
};

MaskedPhoneInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

MaskedPhoneInput.defaultProps = {
  value: ''
};

export default MaskedPhoneInput;
